module.exports = __webpack_public_path__ + "assets/rossette-empty.22db0cdc.svg";